module.exports = __webpack_public_path__ + "img/icon-account-invoice@3x.9cad3141.png";